import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import htmlToPdfmake from "html-to-pdfmake";
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { fadeInRightAnimation } from 'src/@fury/animations/fade-in-right.animation';
import { fadeInUpAnimation } from 'src/@fury/animations/fade-in-up.animation';
import { scaleInAnimation } from 'src/@fury/animations/scale-in.animation';
import { ApiService } from 'src/app/services/api.service';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'fury-customer-agreement-pdf',
  templateUrl: './customer-agreement-pdf.component.html',
  styleUrls: ['./customer-agreement-pdf.component.scss'],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class CustomerAgreementPdfComponent implements OnInit {
  @ViewChild('htmlData', { static: false }) public pdfGenerate!: ElementRef;
  @ViewChild('headerData', { static: false }) public headerData!: ElementRef;
  @ViewChild('footerData', { static: false }) public footerData!: ElementRef;
  pdfData: any;
  id!:any;

  constructor(
    private storageService: StorageService,
    private activeRoute: ActivatedRoute,
    private api: ApiService,
    ) {
      this.id = this.activeRoute.snapshot.paramMap.get('id');
      if(this.id){
        this.getAgreementData(this.id);
      }
     }
  agentDetails!:any;
  ngOnInit(): void { 
    this.agentDetails = this.storageService.getUser();
  }

  async createPdf() {
    (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;
    let DATA = this.pdfGenerate.nativeElement;
    let headerHTML = this.headerData.nativeElement;
    let footerHTML = this.footerData.nativeElement;
    const html = htmlToPdfmake(DATA.innerHTML, {
      defaultStyles:{
     
    },
    tableAutoSize:true
  });
    const header = htmlToPdfmake(headerHTML.innerHTML);
    const footer = htmlToPdfmake(footerHTML.innerHTML);
    const documentDefinition: any = {
      header: header,
      content: html,
      styles: {
        'header': {
          height: '171px',
          'font-family': 'Arial, Helvetica, sans-serif',
          'background-size': '100%',
        },
        'mr-auto': {
          alignment: 'right',
        },
        'marbottom': {
          marginBottom: 10
        },
        'blankheight': {
          height: '40px',
        },
        'strongfont': {
          fontSize: 25,
          alignment: 'center',
          bold: true
        },
        'startfontpara': {
          fontSize: 18,
        },
        'midfontpara': {
          fontSize:15
        },
        'smallfontpara': {
          fontSize:12
        },
        'addfontpara': {
          lineHeight: 0.5
        },
        'listing': {
          listType: 'upper-roman'
        },
        'textcenter': {
          alignment: 'center'
        },
        'textright': {
          alignment: 'right'
        },
        'clear': {
          marginBottom: 10
        },
        'unbreaktxt': {
          unbreakable: false
        },
        'agreementprt': {
          width: 500
        }
        
        
      },
      background: [{
        image: 'headerBackground',
        fit: [595, 842]
        }],
      images: {
        eliteLogo: await this.getBase64ImageFromURL('../../../../assets/img/elite-logo.svg'),
        headerBackground: await this.getBase64ImageFromURL('../../../../assets/img/header-footer.png'),
        qrcode: await this.getBase64ImageFromURL('../../../../assets/img/qr-code.png'),
        squrebullet: await this.getBase64ImageFromURL('../../../../assets/img/squre-bullet.png'),
        img1: await this.getBase64ImageFromURL('../../../../assets/img/icon1.png'),
        img2: await this.getBase64ImageFromURL('../../../../assets/img/icon2.png'),
        img3: await this.getBase64ImageFromURL('../../../../assets/img/icon3.png'),
        img4: await this.getBase64ImageFromURL('../../../../assets/img/icon4.png'),
        img5: await this.getBase64ImageFromURL('../../../../assets/img/icon5.png')
      },
      pageMargins : [50, 120, 50, 90],

     
      pageSize: 'A4',

    };


    pdfMake.createPdf(documentDefinition).print();
  }

  getBase64ImageFromURL(url: any) {
    return new Promise((resolve, reject) => {
      var img = new Image();
      img.setAttribute("crossOrigin", "anonymous");

      img.onload = () => {
        var canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        var ctx = canvas.getContext("2d");
        (ctx as any).drawImage(img, 0, 0);

        var dataURL = canvas.toDataURL("image/png");
        resolve(dataURL);
      };

      img.onerror = error => {
        reject(error);
      };

      img.src = url;
    });
  }

  getAgreementData(id: string) {
    this.api
      .get(`admin/customer-agreement/get-customer-agreement/${id}`)
      .subscribe((res: any) => {
        if (res.body?.customerAgreement) {
          this.pdfData = {...res.body?.customerAgreement,
            coverSystems: res.body?.customerAgreement?.mainPlan?.coveredItems.filter((item:any)=>{
              return item?.itemType === 'systems'
            }),
            coverAppliances: res.body?.customerAgreement?.mainPlan?.coveredItems.filter((item:any)=>{
              return item?.itemType === 'appliances'
            }),
            optionalCoverSystems:  res.body?.customerAgreement?.optionalPlan?.coveredItems.filter((item:any)=>{
              return item?.itemType === 'systems'
            }),
            optionalCoverAppliances:  res.body?.customerAgreement?.optionalPlan?.coveredItems.filter((item:any)=>{
              return item?.itemType === 'appliances'
            }),
          }
        }
      });
  }


}
